__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "aicc-user-portal";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(459), __webpack_require__.e(158)]).then(() => (() => (__webpack_require__(4158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(459), __webpack_require__.e(100), __webpack_require__.e(860)]).then(() => (() => (__webpack_require__(1479))))));
			register("@fontsource-variable/inter", "5.3.0", () => (__webpack_require__.e(537).then(() => (() => (__webpack_require__(537))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(491), __webpack_require__.e(462), __webpack_require__.e(459), __webpack_require__.e(445), __webpack_require__.e(100), __webpack_require__.e(976)]).then(() => (() => (__webpack_require__(2491))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(407), __webpack_require__.e(69)]).then(() => (() => (__webpack_require__(2069))))));
			register("axios", "1.19.0", () => (__webpack_require__.e(544).then(() => (() => (__webpack_require__(7544))))));
			register("module-federation-import-remote", "1.1.0", () => (__webpack_require__.e(715).then(() => (() => (__webpack_require__(8715))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(459)]).then(() => (() => (__webpack_require__(961))))));
			register("react-helmet-async", "1.3.0", () => (Promise.all([__webpack_require__.e(459), __webpack_require__.e(960)]).then(() => (() => (__webpack_require__(1960))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(733), __webpack_require__.e(459), __webpack_require__.e(445), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(9733))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(459), __webpack_require__.e(445)]).then(() => (() => (__webpack_require__(2648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("redux-dynamic-middlewares", "2.2.0", () => (Promise.all([__webpack_require__.e(407), __webpack_require__.e(393)]).then(() => (() => (__webpack_require__(1393))))));
			register("redux-saga", "1.5.1", () => (__webpack_require__.e(383).then(() => (() => (__webpack_require__(7383))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};